<template>
    <div>
        <div class="audio">
            
            <h1>Instilling Values Throughout the Company</h1>
            
            <audio ref="audio32" @timeupdate="onTimeUpdate" controls class="compass" id="audio32" :src="baseurl + 'assets/audios/camp1path2step3tile2.mp3'"></audio>
            
            <div class="transcript">
                <p>In the last section, we looked at the benefits of having shared values in the ownership group, here are the benefits of sharing values throughout your entire organization.</p>
            </div>
        </div>
        
        
        <div class="slide3-2">
            
            <div class="power-element">
                <p class="element-label">Providing a template for decision-making</p>
            </div>
                        
            <div class="col-sm-7 element-description">
                <p>Values are critical when making decisions; employees and managers can handle situations without direct supervision from the owners.</p>
            </div>
                    
            
            <div class="power-element">
                <p class="element-label">Executing strategy</p>
            </div>
                    
            <div class="col-sm-7 element-description">
                <p>When strategy is based on values, people will be more ready and willing to implement it.</p>
            </div>
                
            <div class="power-element">
                <p class="element-label">Making work meaningful</p>
            </div>
                    
            <div class="col-sm-7 element-description">
                <p>Values give meaning to the work, for everyone from owner’s, to managers, to employees. This leads to higher employee performance.</p>
            </div>
                
            <div class="power-element">
                <p class="element-label">Recruiting and Retaining Employees</p>
            </div>
            
            <div class="col-sm-7 element-description">
                <p>Workers are more likely to join, and stay on with, a company with strong, shared values.</p>
            </div>
            
        </div>
    </div>
</template>


<script>

export default {
    name: "audio1",
    components: {},
    data() {
        return {
            currentTime: 0,
        };
    },
    props: {
        model: {},
    },
    computed: { },
    methods: {
        onTimeUpdate() {}
    }
}

</script>